import { NgIf } from '@angular/common';
import {
 ChangeDetectionStrategy,
 Component,
 inject,
 Input,
 OnChanges,
 SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageTitleModel } from '@dtos/hotel.dto';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';

@Component({
 selector: 'iho-plp-page-header',
 templateUrl: './plp-page-header.component.html',
 styleUrls: ['./plp-page-header.component.scss'],
 changeDetection: ChangeDetectionStrategy.OnPush,
 standalone: true,
 imports: [SkeletonComponent, NgIf],
})
export class PlpPageHeaderComponent {
 @Input() dataSource?: PageTitleModel = undefined;
 @Input() prevPageLoading: boolean = false;

 route = inject(ActivatedRoute);
 params = this.route.snapshot.params;
}
